<template>
  <v-expansion-panels class="bookie-schedule-item">
    <v-expansion-panel>
      <v-expansion-panel-header>
        <div>
          <bookie-icon :bookie="bookie" :size="32" />
          {{ bookieName }}
        </div>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <schedule-item
          v-for="(time, index) in times"
          :key="index"
          :start="time.Start"
          :end="time.End"
          v-on:update-start="t => updateStartTime(index, t)"
          v-on:update-end="t => updateEndTime(index, t)"
          v-on:delete-time="t => deleteTime(index)"
          v-on:add-time="addTime"
          v-on:remove-time="t => removeTime(index)"
          :last="index === times.length - 1"
        />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import BookieIcon from "../BookieIcon";
import ScheduleItem from "./ScheduleItem.vue";
import Constants from "../../lib/constants";

export default {
  name: "BookieSchedule",
  components: {
    BookieIcon,
    ScheduleItem
  },
  props: ["schedule"],
  data() {
    return {};
  },
  computed: {
    bookie() {
      return this.schedule.Bookie;
    },
    times() {
      return this.schedule.Times;
    },
    bookieName() {
      return Constants.BOOKIE_DESCRIPTIONS[this.bookie] || this.bookie;
    }
  },
  methods: {
    addTime() {
      this.$emit("add-time");
    },
    removeTime(index) {
      this.$emit("remove-time", index);
    },
    updateStartTime(timeIndex, newValue) {
      const curr = this.schedule.Times;
      curr[timeIndex].Start = newValue;
      this.$emit("updateTimes", curr);
      console.log(`New times: ${JSON.stringify(curr)}`);
    },
    updateEndTime(timeIndex, newValue) {
      const curr = this.schedule.Times;
      curr[timeIndex].End = newValue;
      this.$emit("updateTimes", curr);
      console.log(`New times: ${JSON.stringify(curr)}`);
    }
  }
};
</script>

<style lang="scss">
.bookie-schedule-item.v-expansion-panels {
  border-radius: 0px;
}

.bookie-schedule-item {
  .v-list-item {
    height: 20px;
  }

  .v-expansion-panel-header {
    padding-left: 0px;
  }

  .v-expansion-panel-content__wrap {
    padding-left: 30px;
    padding-right: 0px;
    padding-bottom: 0px;
  }
}
</style>
